import React, { useState } from "react";
import { Button, Checkbox, FormControlLabel, Menu } from "@mui/material";
import ViewColumnIcon from "@mui/icons-material/ViewColumn";

function ColumnsMenuButton({ allColumns, visibleColumns, onToggle }) {
  const [anchor, setAnchor] = useState(null);

  return (
    <>
      <Button
        variant="outlined"
        startIcon={<ViewColumnIcon />}
        onClick={(e) => setAnchor(e.currentTarget)}
        sx={{
          minWidth: { xs: "120px", md: "auto" },
          fontSize: { xs: "10px", md: "12px" },
        }}
      >
        Columns
      </Button>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={() => setAnchor(null)}
        PaperProps={{
          sx: { width: 220, maxHeight: 500, overflowY: "auto", borderRadius: 2 },
        }}
      >
        {allColumns.map((col) => (
          <FormControlLabel
            key={col.key}
            control={
              <Checkbox
                checked={visibleColumns.has(col.key)}
                onChange={() => onToggle(col.key)}
              />
            }
            label={col.label}
            sx={{ pl: 1, pr: 2, display: "flex" }}
          />
        ))}
      </Menu>
    </>
  );
}

export default ColumnsMenuButton;
